<template>
  <nuxt-icon :name="name" />
</template>

<script setup>
const props = defineProps({
  name: {
    required: true,
    type: String,
  },
});
</script>

<style scoped></style>
